import { FilterOption } from '../../components/_WMS/FilterComponent'
import { eTypeStorage } from '../../enums/eTypeStorage'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'stockKeepingUnit',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 2,
    key: 'ean13',
    label: 'EAN13',
    type: 'text'
  },
  {
    order: 3,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 4,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated',
    filterParams: {
      typeStorageId: [eTypeStorage.Externo, eTypeStorage.Mixto]
    }
  },
  {
    order: 5,
    key: 'positionCode',
    label: 'Posición',
    type: 'precreated'
  }
]

export const defaultFilters = []
